
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import iphone from '../../assets/img/iphone.png';
import match from '../../assets/img/match.png';
import chat from '../../assets/img/chat.png';
import like from '../../assets/img/like.png';
import map from '../../assets/img/mapa.png';
import midias from '../../assets/img/Social Media.svg';
import icon from '../../assets/img/icon.svg';
import peaple from '../../assets/img/peaple.svg';
import emoji from '../../assets/img/friendships.svg';
import vector1 from '../../assets/img/vector1dsk.svg';
import vector2 from '../../assets/img/Vector2.png';
import vector3 from '../../assets/img/Vector3.png';
import vector4 from '../../assets/img/Vector4.png';
import vector5 from '../../assets/img/Vector5.png';
import vector6 from '../../assets/img/Vector6.png';
import google from '../../assets/img/boton google play.svg';
import apple from '../../assets/img/boton app store.svg';
import ny from '../../assets/img/nyc.svg';
import arrow from '../../assets/img/arrow.svg';
import estilo from '../../assets/img/background-vector.png';
import background from '../../assets/img/backgroundvector.svg'; // Caminho para a imagem
import { GiBrazilFlag } from "react-icons/gi"; 


const Home = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
    <>
    <header className="header-containerx">
        
            <div className="header-left">
                <img className='logo2'src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
                <a href="/es">Home</a>
                <a href="/embajadores">Embajadores</a>
                <a href="/equiposobr">Equipo Sobr</a>
                <a href="/terminosypolitica">Términos y Políticas</a>
            </nav>
            <div className="header-right">
            <a className='butontranslate' href="/">en-US</a>
            <a className='butontranslate' href="/br">pt-BR</a>
            </div>
        </header>
        <body>
            <div className='div1'>
                <div className="iphone5">
                    <main>
                    <section className="hero2">
                            <h1>¡Conecta con personas que están revolucionando la felicidad!</h1>
                            <p>Sobr es más que una aplicación: es un lugar de encuentro para quienes han elegido un estilo de vida sobrio, lleno de salud y diversión.
                            </p>                   
                        <br></br>
                        <br></br>
                        <button className="demo-button">DESCARGAR AHORA</button>
                    </section>
                    </main>
                    <img src={iphone} alt="iphone" title="iphone" height="500" />
                    
                </div>                
                </div>
                <div className="content2dsk">
                    <img className='match2' src={match} alt="match" title="match" height="500" />  
                    <section>       
                            <h1>Conexiones auténticas</h1>          
                            <p>Nuestro algoritmo de emparejamiento personalizado va más allá de lo superficial. Analizamos tus intereses, preferencias y comportamientos para sugerirte perfiles realmente compatibles. Haz conexiones significativas con personas que comparten tus valores y están comprometidas con la sobriedad.
                            </p>                                    
                    </section>  
                </div>
                <div className="content3dsk">
                    <section>       
                            <h1>Chatea con tus parejas</h1>          
                            <p>Aquí, la comunicación es segura y privada. Utiliza nuestra función de chat para conectar con tus coincidencias en tiempo real. Comparte mensajes, fotos y momentos especiales, construyendo vínculos genuinos y duraderos.
                            </p>                                    
                    </section>  
                    <img className='chat' src={chat} alt="chat" title="chat" height="500" />  
                </div>
                <div className='div2'></div>
                <div className="content4dsk">
                    <img className='like2' src={like} alt="like" title="like" height="500" />  
                    <section>       
                            <h1>Muestra tu verdadera esencia</h1>          
                            <p>Sé tú mismo Crea un perfil auténtico que refleje tu personalidad e intereses. Atrae coincidencias ideales basadas en tu autenticidad y compatibilidad, abriendo la puerta a conexiones reales y significativas.
                            </p>                                    
                    </section>  
                </div>
                <div className='div3'></div>
                <div className="content5dsk">
                    <section className=' divnyc'>       
                            <h1>Descubre nuevos lugares</h1>          
                            <p>Explora lo mejor de la vida sobria con Sobr Places. Descubre eventos, actividades y lugares perfectos para socializar y conocer gente nueva en tu comunidad. Vive experiencias auténticas y refuerza tus vínculos en el viaje hacia una vida más feliz y saludable.
Únete a nosotros en Sobr y descubre un mundo de posibilidades, donde la sobriedad es sinónimo de libertad, alegría y conexión genuina.

</p>                                    
                    </section> 
                    
                    <div className='containerdsk'>
                    <img className="map" src={map} alt="map" title="map" height="500" />
                    </div> 
                </div>
                {/*<div className="content6dsk">
                    <h1>Sobr shouldn’t be somber.</h1>
                    <p>We created Sobr with the belief that being sober isn’t the end of the good times, but the start. Here’s our story in a few more words…</p>
                </div>
                <div className='carddsk'>
                <div className="support-carddsk">
                    <div className="peapledsk">
                        <img src={peaple} alt="members" title="members" />
                    </div>
                    <div className="textdsk">
                        <h2>+190.000</h2>
                        <p>members</p>
                    </div>
                </div>
                <div className="support-carddsk">
                    <div className="icondsk">
                        <img src={icon} alt="support" title="support" />
                    </div>
                    <div className="textdsk">
                        <h2>+3.3M</h2>
                        <p>Support Messages</p>
                    </div>
                </div>
                <div className="support-carddsk">
                    <div className="emojidsk">
                        <img src={emoji} alt="friendships" title="friendships" />
                    </div>
                    <div className="text">
                        <h2>+155,000</h2>
                        <p>friendships</p>
                    </div>
                </div>
                </div>
                <div className='downloaddsk'>
                    <h3> Download the app today! </h3>
                <img className="google3" src={google} alt="Google play" title="Google play" height="38" width="140" />
                </div>
                <div className='div4'>
                <div className="content7dsk">
                    <h1>What our happy customers are saying</h1>
                </div>
                <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div>
                </div> */}
                
                <footer>
                    <div className="footer-contentdsk">
                        <p>Términos de servicio | política de privacidad</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc. Todos los derechos reservados 
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Home;
